module.exports = __webpack_public_path__ + "static/media/Montserrat-SemiBoldItalic.74fbdb73.ttf";